import { deserialize } from 'cerialize'
import { ShortDataModel, PartnerShortModel } from 'Models'
import moment from 'moment'
import { DATE_AND_TIME_FORMAT_REVERSE } from 'Constants/Global'

export class UserLogModel {
	@deserialize public id: number
	@deserialize public event?: string
	@deserialize public event_type?: string
	@deserialize public user?: ShortDataModel
	@deserialize public initiator_full_name?: string
	@deserialize public initiator_email?: string
	@deserialize public created_at?: string
	@deserialize public initiator_partner?: PartnerShortModel
	@deserialize public partner?: PartnerShortModel
	@deserialize public message?: string
	@deserialize public payload?: {
		browser?: string
		browser_version?: string
		forwarded_for?: string
		ip?: string
		platform?: string
		platform_version?: string
		user_agent?: string
	}

	public get time_formatted(): string | undefined {
		return moment(this?.created_at).format(DATE_AND_TIME_FORMAT_REVERSE)
	}

	public get initiator_partner__vat_number(): string | undefined {
		return this?.initiator_partner?.vat_number
	}

	public get user__name(): string | undefined {
		return this?.user?.name
	}

	public get partner__vat_number(): string | undefined {
		return this?.partner?.vat_number
	}
}
